import { render, staticRenderFns } from "./AcuteCareStatus.vue?vue&type=template&id=b3c96156&"
import script from "./AcuteCareStatus.vue?vue&type=script&lang=ts&"
export * from "./AcuteCareStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3c96156')) {
      api.createRecord('b3c96156', component.options)
    } else {
      api.reload('b3c96156', component.options)
    }
    module.hot.accept("./AcuteCareStatus.vue?vue&type=template&id=b3c96156&", function () {
      api.rerender('b3c96156', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboards/columns/AcuteCareStatus.vue"
export default component.exports